import { initializeApp, getApps, getApp } from 'firebase/app';
import { firebaseConfig } from '../config';
import { AppCheck } from 'firebase/app-check';
import { initializeAppCheck } from 'firebase/app-check';
import { ReCaptchaEnterpriseProvider } from 'firebase/app-check';

let appCheckInstance: AppCheck;

export const firebaseApp = (() => {
  const apps = getApps();

  const isFirstInit = apps.length === 0;
  const app = isFirstInit ? initializeApp(firebaseConfig) : apps[0];

  if (!appCheckInstance) {
    appCheckInstance = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  }

  return app;
})();

export { appCheckInstance };
